export default {
      id: "video-event_danger-maneuver-usage",
      viewBox: "0 0 18 23",
      url: __webpack_public_path__ + "img/icons.svg#video-event_danger-maneuver",
      toString: function () {
        return this.url;
      }
    }